<template>
  <div class="right-btn-wrap">
    <span
      v-if="checkPermission(['ROLE_ADMIN', 'ROLE_CYY_USER', 'ROLE_GOVERNMENT'])"
      @click="videoClick"
      >实时农情</span
    >
    <span @click="qjlick">360全景</span>
    <span @click="scienceClick">科普导览</span>
    <span @click="newClick">大事记</span>
  </div>
</template>

<script>
import checkPermission from "@/util/permission";
export default {
  methods: {
    checkPermission,
    qjlick() {
      window.open("https://i.svrvr.com/v2/pano/#/pano/ea5f8f0da0");
    },
    videoClick() {
      window.open("http://api.mmlzdsjpt.com/monitor/index.html");
      // this.$router.push({ path: "/video" });
    },
    scienceClick() {
      this.$router.push({ path: "/science" });
    },
    newClick() {
      this.$store.dispatch("drawer/setRightComponent", "newDrawer");
    }
  }
};
</script>

<style lang="stylus" scoped>
.right-btn-wrap
    position absolute
    right 1%
    top 0.335rem
    cursor pointer
    z-index 7

    span
        color #b4c0db
        background url('~images/index/home/btn-bg.png') no-repeat
        background-size 100% 100%
        width 115px
        height 32px
        line-height 32px
        display inline-block
        text-align center
        font-size 14px
        margin-left 10px
</style>
